import { isNotNil } from "@instacover/utils"

import { db } from "@/database/database"
import { PhotoSlim } from "@/database/helpers/tables"

export type GPS = {
  latitude: number
  longitude: number
}

export type GPSWithAccuracy = GPS & {
  accuracy: number
}

// Prefer adjustedGps over original GPS, otherwise it would re-introduce VIEWPORT_INSIDE_POLYGON error for corrected wall photo
// Photos taken without geolocation access have no coordinates to mark on the map
function pickGps(photo: PhotoSlim): [number, number] | undefined {
  if (photo.adjustedLongitude !== undefined && photo.adjustedLatitude !== undefined) {
    return [photo.adjustedLongitude, photo.adjustedLatitude]
  }

  // photos taken without GPS
  if (photo.longitude === undefined || photo.latitude === undefined) return undefined

  return [photo.longitude, photo.latitude]
}

function gpsPerWallPhoto(wallPhotos: PhotoSlim[], wallToExclude?: number): [number, number][] {
  const photos = wallToExclude ? wallPhotos.filter((photo) => photo.wallNumber !== wallToExclude) : wallPhotos

  return photos.map(pickGps).filter(isNotNil)
}

/**
 * Retrieves all previous GPS coordinates from the wall photos
 * @param wallToExclude Used when re-taking a wall photo, it has not been deleted yet and we dont
 * want to display 2 markers for the same wall
 * @returns Array of previous GPS coordinates
 * @example [[lngWall1, latWall1], [lngWall2, latWall2], ...]
 */
async function getWallPhotosGPS(sessionId: string, wallToExclude?: number): Promise<[number, number][]> {
  const wallPhotos = await db.photo.findByType({
    sessionId,
    type: "Wall",
  })

  return gpsPerWallPhoto(wallPhotos, wallToExclude)
}

export { getWallPhotosGPS, gpsPerWallPhoto, pickGps }
